import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./index.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import SignIn from "./pages/SignIn";
import Onboarding from "./pages/Onboarding";
import VerificationStatus from "./pages/VerificationStatus";
import AutoCancelRules from "./pages/AutoCancelRules";
import CostReport from "./pages/CostReport";
import AccountBilling from "./pages/AccountBilling";

const qc = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 30_000 } },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <Routes>
          <Route path="/signin" element={<SignIn />} />
          <Route path="/dashboard" element={<Navigate to="/orders" replace />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/orders" element={<VerificationStatus />} />
          <Route path="/auto-cancel" element={<AutoCancelRules />} />
          <Route path="/cost-report" element={<CostReport />} />
          <Route path="/billing" element={<AccountBilling />} />
          <Route path="/" element={<Navigate to="/orders" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
